"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractAdsParser = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
/**
 * The ads parser has one single responsibility: To detect ads and create IAdBlock objects and emit them.
 */
class AbstractAdsParser extends js_player_shared_1.EmitterBaseClass {
    constructor(clips = [], isLive = false) {
        super();
        this.clips = clips;
        this.isLive = isLive;
    }
    isTimeUTC() {
        return this.isLive;
    }
}
exports.AbstractAdsParser = AbstractAdsParser;
//# sourceMappingURL=AbstractAdsParser.js.map